import { useQuery } from "@tanstack/react-query";
import { performanceService } from "../../api/performanceService";
import { getEmployeeId } from "../../utils/session";
import { ACTION_STATUSES, PERF_KEYS } from "./performanceUtils";

const toArray = (data) => (Array.isArray(data) ? data : (data?.data ?? []));
const NO_RETRY_ON_403 = (count, error) =>
  error?.response?.status !== 403 && count < 2;

export const useMyEvaluations = () =>
  useQuery({
    queryKey: PERF_KEYS.mine,
    queryFn: async () => toArray(await performanceService.getMine()),
    enabled: !!getEmployeeId(),
    retry: NO_RETRY_ON_403,
  });

export const useToEvaluate = (includeDone, { enabled = true } = {}) =>
  useQuery({
    queryKey: PERF_KEYS.toEvaluate(includeDone),
    queryFn: async () =>
      toArray(await performanceService.getToEvaluate({ includeDone })),
    enabled: enabled && !!getEmployeeId(),
    retry: NO_RETRY_ON_403,
  });

export const useEvaluation = (id) =>
  useQuery({
    queryKey: PERF_KEYS.details(id),
    queryFn: () => performanceService.getById(id),
    retry: NO_RETRY_ON_403,
  });

// Menu visibility and badges for the Performance section.
export const usePerformanceNav = () => {
  const mine = useMyEvaluations();
  const open = useToEvaluate(false);
  // History is only needed to decide visibility when nothing is open.
  const done = useToEvaluate(true, {
    enabled: open.isSuccess && open.data.length === 0,
  });

  return {
    myActions: (mine.data ?? []).filter((e) =>
      ACTION_STATUSES.includes(e.status),
    ).length,
    toRate: (open.data ?? []).filter((e) => e.status === "PENDING_EVALUATION")
      .length,
    isEvaluator: (open.data?.length ?? 0) > 0 || (done.data?.length ?? 0) > 0,
  };
};
